const doc = [({"en":({"adminHotelMail":({"saveInformation":"Save {{type}} information", "saveSetting":"Save mail settings"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;